export default "__VITE_ASSET__BOenMhH8__"